<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import InputBox from '../../components/InputBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'SurveyQ4SSComment',
  components: {
    InputBox,
    Button: SolutoButton
  },
  computed: {
    ...mapGetters(['supportServiceComment'])
  },
  methods: {
    ...mapActions(['changeSupportServiceComment']),

    saveText (event: string) {
      this.changeSupportServiceComment(event);
    },
    nextScreen () {
      router.push({ path: '/survey/question5Faq/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q2">
        <p class="with-margin">{{ $t('survey_04_ss') }}</p>
        <input-box @change="saveText" :text="supportServiceComment"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
